import { IClient } from "intake_shared/src/types";
import * as React from "react";
import { Dialog } from "../../../bits/Dialog/Dialog";
import { Select } from "../../../bits/Select/Select";
import moment from "../../../../../utils/app_moment";

interface AppointmentEmailProps {
    client: IClient | undefined;
    show: boolean;
    onClose: () => void;
    onConfirm: (value: string, option?: string) => void;
    loading: boolean;
    type: string;
}

type Option = {
    label: React.ReactNode;
    value: string;
};

export default function AppointmentEmail({
    client,
    show,
    onClose,
    onConfirm,
    type,
}: AppointmentEmailProps) {
    const [selectedAppointmentId, setSelectedAppointmentId] = React.useState("");

    const handleConfirm = async (option?: string) => {
        if (selectedAppointmentId) {
            try {
                await onConfirm(selectedAppointmentId, option);
                setSelectedAppointmentId("");
                onClose();
            } catch (error) {
                console.error("Error sending email:", error);
            }
        }
    };

    const appointmentOptions = React.useMemo(() => {
        const appointmentsToDisplay =
            type === "appointment_confirmed_clinician_template"
                ? client?.confirmed_bookings
                : [
                      ...(client?.held_bookings ?? []),
                      ...(client?.confirmed_bookings ?? []),
                  ];
        return appointmentsToDisplay?.map((b) => ({
            label: (
                <>
                    {b.clinician_display_name} / {b.requested_service} /{" "}
                    {moment(b.starting_date || b.start).format("MMMM Do, h:mm A")}
                </>
            ),
            value: b.id,
        }));
    }, [type, client?.held_bookings, client?.confirmed_bookings]);

    return (
        <Dialog
            open={show}
            onClose={onClose}
            title={
                type === "appointment_confirmed_clinician_template"
                    ? "Send Appointment Confirmed Email"
                    : "Send Appointment Held Clinician Consult Email"
            }
            onCancel={onClose}
            onSave={
                type === "appointment_confirmed_clinician_template"
                    ? () => handleConfirm("send_clinician_only")
                    : () => handleConfirm()
            }
            isSubmitBtnDisabled={!selectedAppointmentId}
            saveText={
                type === "appointment_confirmed_clinician_template"
                    ? "Send Clinician Only"
                    : "Send Email"
            }
            backBtnText={
                type === "appointment_confirmed_clinician_template"
                    ? "Send Client Only"
                    : undefined
            }
            onBackBtnClick={() => {
                handleConfirm("send_client_only");
            }}
            isBackBtnDisabled={!selectedAppointmentId}
        >
            <form>
                <Select
                    label="Select appointment to send email for"
                    options={appointmentOptions}
                    value={appointmentOptions?.find(
                        (o) => o.value === selectedAppointmentId
                    )}
                    onChange={(val) =>
                        setSelectedAppointmentId((val as Option).value)
                    }
                    isLongListInDialog
                />
            </form>
        </Dialog>
    );
}
